/*
 * @Author: 曹捷
 * @Date: 2021-01-08 16:45:30
 * @LastEditors: 曹捷
 * @LastEditTime: 2021-10-21 17:29:48
 * @Description: 路由 调用实例
 */
import createTempRouter from 'obit-wui/router'
import { name } from './../../package.json'

/**
 * @param {String} basrRouter 
 * 乾坤环境 需要区分 基础路由
 * @returns 
 */
export default function () {
  let router = createTempRouter({
    template: [],
    mode: '/'
  }, name)
  const modulesFiles = require.context("./modules", true, /\.js$/);
  let detailList = []
  function getAllDetailsPage (item) {
    item && item.forEach(element => {
      if (element.meta && element.meta.parentPath) {
        detailList.push({
          path: element.path,
          name: element.name,
          meta: element.meta
        })
      }
      if (element.children && element.children.length > 0) {
        getAllDetailsPage(element.children)
      }
    })
  }
  modulesFiles.keys().forEach(modulePath => {
    const value = modulesFiles(modulePath);
    router.options.routes.push(...value.default)
    getAllDetailsPage(value.default)
    value.default.forEach(element => {
      router.addRoute(element)
    })
  })
  router.detailList = detailList
  return router
}